import { transferEffect } from "./transfer";
import { scrollEffect } from "./scrollEffect";
import verifyFunctions from "./verification";

export const useTransferEffect = transferEffect;
export const useScrollEffect = scrollEffect;
export const handleVerify = verifyFunctions;
